export const NAME = 'guarantorsEdit';

export const RADIO_OPTIONS_IDS = {
	byOrganizeStructure: 'byOrganizeStructure',
	outOrganizeStructure: 'outOrganizeStructure',
};
